export default __webpack_public_path__ + "static/media/scdream4.de9c7721.woff";